<template>
	<div class="bg_content">
		<div class="device_head">
			<span style="color: #b2b2b2">门禁管理 /</span>
			<span style="color: #5c5c5c"> 门禁事件</span>
		</div>
		<div class="content_body">
			<el-card shadow="never" style="height: 80px;">
				<el-row :gutter="24">
					<el-col :span="4">
						<el-input placeholder="设备名称、SN序列号" v-model="searchQuery.deviceSn" clearable></el-input>
					</el-col>
					
					<el-col :span="4">
						<el-select placeholder="事件类型" v-model="searchQuery.eventType" clearable>
							<el-option v-for="(item,index) in eventTypeList" :key="index" :value="item.id" :label="item.name"></el-option>
						</el-select>
					</el-col>
					<el-col :span="8">
						<el-date-picker  start-placeholder="开始日期" end-placeholder="结束日期"
							type="daterange" value-format="yyyy-MM-dd"
							v-model="passageDate"></el-date-picker>
					</el-col>
					<div>
						<el-col :span="4">
							<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
						</el-col>
					</div>
				</el-row>
			</el-card>
			<el-card class="card_table" shadow="never">
				<el-table :data="tableData" :header-cell-style="{background: '#F5F6FA',color: '#5C5C5C',}" height="580">
					<template slot="empty">
						<div>
							<img src="@/assets/nodata.png" class="nodata" />
							<div class="nodata_text">无数据</div>
						</div>
					</template>
					<el-table-column label="设备名称"  >
						<template slot-scope="scope">
							{{scope.row.device?.name}}
						</template>
					</el-table-column>
					<el-table-column label="SN序列号" prop="deviceSn"/>
					<el-table-column label="事件类型" prop="eventType" :formatter="eventTypeFormatter"/>
					<el-table-column label="事件描述" prop="eventRemark"/>
					<el-table-column label="事件时间" prop="createTime" />
					<!-- <el-table-column label="操作" width="200">
						<template slot-scope="scope">
							<el-link type="primary" style="margin-right: 25px;">查看</el-link>
						</template>
					</el-table-column> -->
				</el-table>
				<el-pagination v-model:current-page="searchQuery.pageNum" :page-size="searchQuery.pageSize"
					layout="total, ->, prev, pager, next" :total="tableTotal" @current-change="handleCurrentChange" />
			</el-card>
		</div>

		<company-footer-info />
	</div>
</template>

<script>
	import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
  import dayjs from 'dayjs'
	import {
		doorEventApi
	} from "@/api/nexus/doorEvent"
	export default {
		components: {
			CompanyFooterInfo,
		},
		data() {
			return {
				//查询条件timerange: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), new Date()],
				passageDate: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), new Date()],
				searchQuery: {
					deviceSn: '',
					eventType: '',
					startTime:'',
					endTime:'',
					pageSize: 20,
					pageNum: 1,
				},
				//表格数据
				tableData: [],
				tableTotal: 0,
				eventTypeList:[
					{id:0,name:'正常'},
					{id:80,name:'非法卡'},
					{id:81,name:'门超时未关'},
					{id:82,name:'防拆'},
					{id:83,name:'火警'},
					{id:84,name:'胁迫开门'},
					{id:85,name:'防潜回'},
					{id:86,name:'强制闯入'},
					{id:87,name:'合法卡联动'},
					{id:88,name:'一键戒严'},
					{id:89,name:'黑名单报警'},
					{id:91,name:'陌生人'},
					{id:92,name:'已过有效次数'},
					{id:93,name:'读头数据校验错误'},
					{id:94,name:'防盗报警'},
					{id:95,name:'报警解除'},
					{id:96,name:'区域人数已满'},
				]
			}
		},
		methods: {
		/*	changeDate(arr){
				arr.length >0 ? this.searchQuery.startTime = arr[0]: this.searchQuery.startTime = ''
				arr.length >0 ? this.searchQuery.endTime = arr[1]: this.searchQuery.endTime = ''
			},*/
			//格式化事件类型
			eventTypeFormatter(row){
				return this.eventTypeList.find(item => {return item.id === row.eventType}).name
			},
			handleSearch() {
				this.searchQuery.pageNum = 1;
				this.getDoorEventList();
			},
			//下一页
			handleCurrentChange(page) {
				this.searchQuery.pageNum = page;
				this.getDoorEventList();
			},
			//获取数据
			async getDoorEventList() {
        this.searchQuery.startTime = '';
        this.searchQuery.endTime = '';
        if(this.passageDate && this.passageDate.length == 2){
          this.searchQuery.startTime = this.passageDate[0] ? dayjs(this.passageDate[0]).format('YYYY-MM-DD') : '';
          this.searchQuery.endTime = this.passageDate[1] ? dayjs(this.passageDate[1]).format('YYYY-MM-DD') : '';
        }
				let {code,data} = await doorEventApi.page(this.searchQuery);
				if(code == 200){
					this.tableData = data.list;
					this.tableTotal = parseInt(data.total);
				}
			}
		},
		mounted() {
			this.getDoorEventList();
		}
	}
</script>

<style scoped>
	.bg_content {
		width: 100%;
		padding: 16px 20px;
		background: #f4f7fc;
		height: 100%;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
	}

	.content_body {
		margin-top: 20px;
		height: 100%;
	}

	.table_scope_t {
		color: #4192F3;
	}

	.table_scope_f {
		color: #EE7B32;
	}

	.time_single {
		flex: 0 0 116px;
		/* 不伸缩，基准宽度 116px */
		width: 100px;
		/* 实际宽度 100px */
		height: 30px;
		line-height: 30px;
		text-align: center;
		font-size: 16px;
		color: #1a1a1a;
		background: #dee4ed;
		border-radius: 4px;
		margin-right: 8px;
		white-space: nowrap !important;
		overflow: hidden !important;
		text-overflow: ellipsis !important;

	}

	.card_table {
		height: calc(100% - 80px) !important;
	}

	.search-icon {
		width: 18px;
		height: 18px;
		vertical-align: middle;
	}
</style>